"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routineAsyncApi = routineAsyncApi;
exports.wechatAsyncApi = wechatAsyncApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 公众号模板消息同步
 */
function wechatAsyncApi() {
  return (0, _request.default)({
    url: '/admin/platform/wechat/template/whcbqhn/sync',
    method: 'post'
  });
}

/**
 * 小程序模板消息同步
 */
function routineAsyncApi() {
  return (0, _request.default)({
    url: '/admin/platform/wechat/template/routine/sync',
    method: 'post'
  });
}